import * as React from "react";
function SvgToneMixed(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M32 16A16 16 0 1116 0a16 16 0 0116 16zm-22-5a2 2 0 102 2 2 2 0 00-2-2zm12 0a2 2 0 102 2 2 2 0 00-2-2zm-7.55 13.89l3.67-1.83 3.64.91a1 1 0 00.48-1.97l-4-1a1 1 0 00-.69.08l-3.67 1.83-3.64-.91a1 1 0 10-.48 2l4 1a1 1 0 00.69-.08z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgToneMixed);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
